import { render, staticRenderFns } from "./FormSelectBasic.vue?vue&type=template&id=54d0875e&"
import script from "./FormSelectBasic.vue?vue&type=script&lang=js&"
export * from "./FormSelectBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports